import React, { useEffect, useState } from "react";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import EmptyDragArea from "./EmptyDragArea.js";
import bytesToDisplayHelper from "utils/bytesToDisplayHelper.js";
import usePaginationUploader from "components/Pages/Home/Helpers/usePaginationUploader.js";
import PreviewItem from "./PreviewItem.js";
import createPreview from "components/Pages/Home/Helpers/createPreview.js";

const FormsUploader = ({ filesProgress, dragged }) => {
  const [previews, setPreviews] = useState({});

  const {
    uploaderGetFiles,
    uploaderCancelAll,
    getSize,
    getIsUppy,
    getUploading,
  } = useUploader();

  const { getTextByKey } = useContent();

  const size = bytesToDisplayHelper(getSize());

  const { fileList, UplaoderPaginator, pageNum } = usePaginationUploader();

  const generatePreviews = async (fileList) => {
    for (let i = 0; i < fileList.length; i++) {
      if (previews[fileList[i].id]) continue;
      const file = fileList[i];
      const fileData = getIsUppy() ? file.data : file.file;

      const preview = await createPreview(fileData, fileData.type);

      setPreviews((prevPreviews) => ({
        ...prevPreviews,
        [file.id]: preview,
      }));

      await new Promise((resolve) => setTimeout(resolve, 100)); // Add a delay of 100ms
    }
  };

  const generateAndSetPreviews = async () => {
    const batchSize = 5;
    for (let i = 0; i < fileList.length; i += batchSize) {
      const batchFiles = fileList.slice(i, i + batchSize);
      await generatePreviews(batchFiles, setPreviews);
    }
  };

  useEffect(() => {
    generateAndSetPreviews();
  }, [pageNum, fileList.length]);

  return (
    <div className="jm-form-uploader-body">
      {uploaderGetFiles().length > 0 ? (
        <>
          {getUploading() ? null : (
            <div className="jm-form-uploader-files-header">
              <div className="counter-files">
                {getTextByKey("selected-multiple-files-text").replace(
                  "%{smart_count}",
                  uploaderGetFiles().length
                )}
                , {size.size + size.type}
              </div>
              <div className="flex-spacer"></div>
              <div
                className="remove-all-files"
                onClick={() => {
                  setPreviews({});
                  uploaderCancelAll();
                }}
              >
                {getTextByKey("remove-all")}
              </div>
            </div>
          )}
          <div className="jm-form-uploader-files-preview">
            {fileList.map((file) => (
              <PreviewItem
                key={file.name + file.size + file.id}
                file={file}
                preview={previews[file.id]}
                progress={filesProgress[file.id]}
              />
            ))}
            <UplaoderPaginator className="list-pagination" />
          </div>
        </>
      ) : null}
      <EmptyDragArea dragged={dragged} />
    </div>
  );
};
export default FormsUploader;
